import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Edit, ArrowRight, PlusCircle } from 'react-feather';

const formatCurrency = (value) => {
    if (value == null || value === '') return '-';
    const num = Number(value);
    if (Number.isNaN(num)) return '-';
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(num);
};

const formatDateTime = (value) => {
    if (!value) return '-';
    try {
        return new Date(value).toLocaleString('tr-TR', {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit'
        });
    } catch { return '-'; }
};

const PaymentCollectionListModal = ({
    isOpen,
    toggle,
    title = 'Tahsilatlar',
    headerExtra = null,
    paymentCollections = [],
    isLoading = false,
    submittingId = null,
    onEdit,
    onSendToCover,
    onAdd,
    isSendToCoverDisabled,
    isAddDisabled = false,
}) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="xl" backdrop="static">
            <ModalHeader toggle={toggle}>{title}</ModalHeader>
            <ModalBody>
                {headerExtra}

                {isLoading ? (
                    <div className="text-center p-4">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Yükleniyor...</span>
                        </div>
                        <p className="mt-3 mb-0">Tahsilatlar yükleniyor...</p>
                    </div>
                ) : paymentCollections.length === 0 ? (
                    <div className="text-center p-4">Bu dosya için kayıtlı tahsilat bulunamadı.</div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th style={{ whiteSpace: 'nowrap' }}>Tahsilat No</th>
                                    <th style={{ whiteSpace: 'nowrap' }}>Tip</th>
                                    <th style={{ whiteSpace: 'nowrap' }}>Tutar</th>
                                    <th style={{ whiteSpace: 'nowrap' }}>Tarih</th>
                                    <th style={{ whiteSpace: 'nowrap' }}>Ödeme Yöntemi</th>
                                    <th style={{ whiteSpace: 'nowrap' }}>Makbuz No</th>
                                    <th style={{ whiteSpace: 'nowrap' }}>İşlemler</th>
                                    <th style={{ whiteSpace: 'nowrap' }}>Kapağa Gönder</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paymentCollections.map(collection => {
                                    const collectionRowId = collection.id || collection._id;
                                    const isSubmittingToCover = submittingId === collectionRowId;
                                    const sendDisabled = typeof isSendToCoverDisabled === 'function'
                                        ? isSendToCoverDisabled(collection, isSubmittingToCover)
                                        : isSubmittingToCover;

                                    return (
                                        <tr key={collectionRowId || collection.paymentCollectionNumber}>
                                            <td style={{ whiteSpace: 'nowrap' }}>{collection.paymentCollectionNumber || '-'}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{collection.paymentCollectionType || '-'}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{formatCurrency(collection.amount)}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{formatDateTime(collection.date)}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{collection.paymentMethod || '-'}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{collection.receiptNumber || '-'}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>
                                                {!collection.wasSentToCompensation && onEdit && (
                                                    <button
                                                        className="btn btn-outline-warning btn-sm"
                                                        onClick={() => onEdit(collection)}
                                                        title="Düzenle"
                                                    >
                                                        <Edit size={14} />
                                                    </button>
                                                )}
                                            </td>
                                            <td style={{ whiteSpace: 'nowrap' }}>
                                                {!collection.wasSentToCompensation ? (
                                                    onSendToCover && (
                                                        <button
                                                            className="btn btn-outline-danger btn-sm"
                                                            onClick={() => onSendToCover(collection)}
                                                            disabled={sendDisabled}
                                                            title="Kapağa Gönder"
                                                        >
                                                            {isSubmittingToCover ? (
                                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                            ) : (
                                                                <ArrowRight size={14} />
                                                            )}
                                                        </button>
                                                    )
                                                ) : (
                                                    <span className="badge bg-success">Gönderildi</span>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                {onAdd && (
                    <button
                        className="btn btn-success d-flex align-items-center ms-2"
                        onClick={onAdd}
                        disabled={isAddDisabled}
                    >
                        <PlusCircle size={16} className="me-2" />
                        Tahsilat Ekle
                    </button>
                )}
                <button className="btn btn-secondary" onClick={toggle}>
                    Kapat
                </button>
            </ModalFooter>
        </Modal>
    );
};

export default PaymentCollectionListModal;
